import { useEffect } from 'react';
import { useWatch } from 'react-hook-form';

/**
 * Scroll to the first error when any
 * Set stepFailed if any error
 * @param errors
 * @param formValues
 * @param activeStep
 * @param setStepFailed
 * @param scrollToFirstError
 * @param control
 */
const useValidationEffects = ({ errors, activeStep, setStepFailed, control }) => {
    const formValues = useWatch({ control });

    useEffect(() => {
        scrollToFirstError(errors);
    }, [errors, scrollToFirstError]);

    useEffect(() => {
        const timer = setTimeout(() => {
            if (Object.keys(errors).length > 0) {
                setStepFailed(activeStep);
            } else {
                setStepFailed(null);
            }
        }, 50);

        return () => clearTimeout(timer);
    }, [errors, formValues, activeStep, setStepFailed]);
};

export default useValidationEffects;

/**
 * Scrolls to the first form field that has an error.
 *
 * @param {Object} errors - An object containing form errors.
 */
const scrollToFirstError = (errors) => {
    const firstErrorKey = Object.keys(errors)[0];
    if (firstErrorKey) {
        const firstErrorField = document.querySelector('.Mui-error');
        if (firstErrorField) {
            firstErrorField.scrollIntoView({ behavior: 'smooth', block: 'start' });
            window.scrollBy(0, -40);
        }
    }
};
